import { useCallback } from "react";

import FlexWrapper, { AlignItems } from "@gx/dls/containers/FlexWrapper";
import CheckboxInput from "@gx/dls/inputs/CheckboxInput";
import Text, { TextSize } from "@gx/dls/text/Text";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import SourceIcon from "@/pages/sources/components/SourceIcon";

interface SelectProjectSourceCardHeaderProps {
  source: SourceResource;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelectChange: () => void;
}

const SelectProjectSourceCardHeader = ({
  source,
  isSelected,
  isDisabled,
  onSelectChange,
}: SelectProjectSourceCardHeaderProps) => {
  const handleSelectChange = useCallback(() => {
    onSelectChange();
  }, [onSelectChange]);

  return (
    <FlexWrapper alignItems={AlignItems.CENTER} gap={16}>
      <CheckboxInput isChecked={isSelected} isDisabled={isDisabled} onChange={handleSelectChange} />
      <SourceIcon sourceType={source.sourceType} />
      <Text size={TextSize.BODY_LG}>{source.name}</Text>
    </FlexWrapper>
  );
};

export default SelectProjectSourceCardHeader;
